import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

export default  function ReCaptchaProvider({ children }){
    return (
        <GoogleReCaptchaProvider reCaptchaKey="6LezFTUfAAAAADpXx2_DIsEOgSbIQNPHGA9Hw47V">
            {children}
        </GoogleReCaptchaProvider>
    )
}